import { useEffect, useRef, useState } from 'react';
import kkpService from '../services/kkpService';

export function useKkpClientSearch(query, { minLength = 2, dolibarrOnly = false } = {}) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    if (abortRef.current) {
      abortRef.current.abort();
      abortRef.current = null;
    }

    const q = String(query ?? '').trim();
    if (q.length < minLength) {
      setSuggestions([]);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    timerRef.current = setTimeout(async () => {
      const controller = new AbortController();
      abortRef.current = controller;
      try {
        const clients = await kkpService.searchDolibarrClients(q, {
          signal: controller.signal,
          dolibarrOnly,
        });
        if (!controller.signal.aborted) {
          setSuggestions(clients);
        }
      } catch (err) {
        if (err?.name === 'AbortError' || controller.signal.aborted) {
          return;
        }
        setSuggestions([]);
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    }, 250);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      if (abortRef.current) {
        abortRef.current.abort();
        abortRef.current = null;
      }
    };
  }, [query, minLength, dolibarrOnly]);

  return { suggestions, loading };
}
